// tslint:disable:max-classes-per-file
var ContactVm = /** @class */ (function () {
    function ContactVm() {
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.officePhone = '';
        this.officePhoneExt = '';
        this.cellPhone = '';
    }
    return ContactVm;
}());
export { ContactVm };
var ReportFiltersVm = /** @class */ (function () {
    function ReportFiltersVm() {
        this.voyageLoadListVm = new VoyageLoadListVm();
        this.filterVm = [];
    }
    return ReportFiltersVm;
}());
export { ReportFiltersVm };
var VoyageLoadListVm = /** @class */ (function () {
    function VoyageLoadListVm() {
        this.fromDate = 0;
        this.toDate = 0;
        this.view = '';
        this.group = '';
        this.site = '';
        this.market = '';
    }
    return VoyageLoadListVm;
}());
export { VoyageLoadListVm };
var FilterVm = /** @class */ (function () {
    function FilterVm() {
        this.module = '';
        this.component = '';
        this.value = '';
    }
    return FilterVm;
}());
export { FilterVm };
var ChangePasswordVm = /** @class */ (function () {
    function ChangePasswordVm() {
        this.newPassword = '';
        this.confirmPassword = '';
    }
    return ChangePasswordVm;
}());
export { ChangePasswordVm };
